import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-steel py-5 sm:py-8" data-id="element-30" data-mp="1hd1nhy7fx7zi">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-31" data-mp="1hdumgd05qt73">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-32" data-mp="1cf02h7qgeyle">
          Frequently asked <span className="text-electric" data-id="element-33" data-mp="2a2s0u51905uk">questions</span>
        </h2>

        <div className="mt-3 divide-y divide-steel overflow-hidden rounded-lg border-2 border-navy bg-white" data-id="element-34" data-mp="2535ri6ojj9r1">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const Icon = isOpen ? MinusIcon : PlusIcon;
          return <div key={faq.question} data-id="element-35" data-mp="1v4g643xfr761" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-3 px-3.5 py-2.5 text-left transition-colors duration-150 ease-out hover:bg-steel/60" data-id="element-36" data-mp="oow35ckatl07">
                  <span className="font-display text-sm font-bold leading-tight text-navy sm:text-base" data-id="element-37" data-mp="1pkqmfmaci8qd">
                    {faq.question}
                  </span>
                  <Icon className="h-4 w-4 shrink-0 text-electric" strokeWidth={3} aria-hidden="true" data-id="element-38" data-mp="1fnc7jr42ls06" />
                </button>
                {isOpen && <p id={`faq-${i}`} className="px-3.5 pb-2.5 text-sm leading-snug text-muted sm:text-[15px]" data-id="element-39" data-mp="16np7p9qzou98">
                    {faq.answer}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}